import { type Clip } from '@air/api/types';

import { WORKSPACE_AGENT_PROMPT_CARD_IMAGE_COUNT } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentImprovedNullState';
import { type WorkspaceAgentPromptCardThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/prompt-cards/WorkspaceAgentPromptCardImageStack';

/** Structural minimum, so tests can pass a plain object instead of a full `Clip`. */
type WorkspaceAgentPromptCardSearchClip = Pick<Clip, 'ext'> & {
  assets: {
    image?: string;
  };
};

export const toWorkspaceAgentPromptCardThumbnails = (clips: readonly WorkspaceAgentPromptCardSearchClip[]) => {
  const thumbnails: WorkspaceAgentPromptCardThumbnail[] = [];

  for (const clip of clips) {
    const thumbnailUrl = clip.assets.image;
    const ext = clip.ext || undefined;

    if (!thumbnailUrl && !ext) {
      continue;
    }

    thumbnails.push(thumbnailUrl ? { thumbnailUrl } : { ext });

    if (thumbnails.length === WORKSPACE_AGENT_PROMPT_CARD_IMAGE_COUNT) {
      break;
    }
  }

  return thumbnails;
};
